import ActionManager from "./base";
import userAPI from "../api/user";
import { signUpStart, signUpSuccess, signUpError, signUpInvalid } from "../actions/sign_up";
import { userLogin } from "../actions/user";
import UserStore, { saveUserRole } from "../lib/user_store";
import { updateCurrentRole } from "../actions/account";

class SignUpActionManager extends ActionManager {
  defaultErrorMessage() {
    return "Uh oh, something went wrong signing up. Please try again later.";
  }

  defaultPreCallActionCreator() {
    return signUpStart;
  }
  defaultSuccessActionCreator() {
    return signUpSuccess;
  }

  default400ActionCreator() {
    return signUpInvalid;
  }

  defaultErrorActionCreator() {
    return signUpError;
  }

  execute() {
    return userAPI.signUp(this.args.formJSON);
  }

  responseOK(dispatch, json) {
    if (this.args.forRole) {
      dispatch(updateCurrentRole(this.args.forRole));
      saveUserRole(this.args.forRole);
    }
    dispatch(userLogin(json));
    UserStore.save(json);
    super.responseOK(dispatch, json);
  }
}

export default SignUpActionManager;
